export default __webpack_public_path__ + "static/media/MacArmour Texture.74423910.png";